module.exports = __webpack_public_path__ + "img/webDevelopmeet.b1762026.jpg";